import StoredLayout from '../../layouts/StoredLayout'
import Validation from './Validation'
export default StoredLayout(Validation)
